export class FilterProducts {
    constructor() {
        this.currPage = 1
        this.searchParams = new URLSearchParams(window.location.search)
        this.data = window.location.search
        this.$body = $('body')
        this.selectors = {
            form: '.js_products-form',
            select: '.js_select-filter',
            checkbox: '.js_checkbox',
            checkboxSize: '.js_checkbox-size',
            paginationBtn: '.js_pagination-btn',
            scrollEl: '.js_scroll',
            unselectBtn: '.js_unselect',
            clearFilterBtn: '.js_clear-filter',
            clearItemBtn: '.js_clear-item'
        }
    }

    init() {
        const { select, checkbox, checkboxSize, paginationBtn, unselectBtn, clearFilterBtn, clearItemBtn } = this.selectors

        this.initSelect(select)
        this.initScrollStyle(this.selectors.scrollEl)
        this.onChange(checkbox)
        this.onChangeSize(checkboxSize)
        this.removeDoubleSort()
        this.onChangePage(paginationBtn)
        this.unselectList(unselectBtn)
        this.clearFilter(clearFilterBtn)
        this.clearItem(clearItemBtn)
    }

    spinnerAdd(spinnerId, loaderClass = 'loader') {
        $('.content').append(`<div id="${spinnerId}" class="loaderWrapper"><div class="${loaderClass}"></div></div>`)
    }

    remove(spinnerId) {
        $(`#${spinnerId}`).remove()
    }

    initSelect(el) {
        $(el).each((_, element) => {
            let $thisSelect = $(element)
            $thisSelect.select2({
                minimumResultsForSearch: Infinity,
                dropdownParent: $thisSelect.parent()
            }).on('select2:select', () => {
                this.currPage = 1
                this.getProducts()
            })
        })
    }

    getProducts(data = null, isClear = false, search = null) {
        this.spinnerAdd('js_pagination-spinner')
        this.togglePanel()
        this.data = data ?? $(this.selectors.form).serialize() + `&page=${this.currPage}`
        let currUrl = `${window.location.origin}${window.location.pathname}?${this.data}`

        if (isClear) {
            this.data = null
            currUrl = `${window.location.origin}${window.location.pathname}`
        }

        if (search) {
            this.data = this.removeSearchParam(this.data)
            currUrl = this.removeSearchParam(currUrl)
            this.data = this.removeSortParam(this.data)
            currUrl = this.removeSortParam(currUrl)
            this.data = this.cleanUrl(this.data)
            currUrl = this.cleanUrl(currUrl)
            this.data = `${this.data}&search=${search}&sort=rank`
            currUrl = `${currUrl}&search=${search}&sort=rank`
        }

        let productsPage = $(this.selectors.form).attr('data-page')
        let productsPageId = $(this.selectors.form).attr('data-id')
        let locale = $(this.selectors.form).attr('data-local')

        if (productsPage && productsPageId) {
            let params = new URLSearchParams(this.data)
            let matchingValues = [...params.entries()]
                .filter(([key]) => key.startsWith(productsPage))
                .map(([, value]) => value)

            const newUrl = `${window.location.origin}/${locale}/all-sneakers?${this.data}`

            if ($('.js_checkbox[name="brands[]"]:checked').length === 0) {
                window.history.replaceState(null, null, newUrl)
                window.location.reload()
            }

            if (matchingValues.length > 1 || (matchingValues.length === 1 && matchingValues[0] != productsPageId)) {
                window.history.replaceState(null, null, newUrl)
                window.location.reload()
            }
            else {
                window.history.replaceState(null, null, currUrl)
            }
        } else {
            window.history.replaceState(null, null, currUrl)
        }

        $.ajax({
            url: $(this.selectors.form).attr('action'),
            method: $(this.selectors.form).attr('method'),
            headers: { Accept: 'application/json' },
            crossDomain: true,
            data: this.data,
            success: (response) => {
                this.remove('js_pagination-spinner')
                $('.js-wrap-cnt').html(response)
                this.initSelect(this.selectors.select)
                this.initScrollStyle(this.selectors.scrollEl)
                this.removeDoubleSort()
            },
            error: () => {
                this.remove('js_pagination-spinner')
            }
        })
    }

    removeSearchParam(url) {
        return url.replace(/(\?|&)search=[^&]*/g, (match, p1) => (p1 === '?' ? '?' : ''))
            .replace(/\?$/, '') // Remove trailing '?' if left behind
            .replace(/&$/, '') // Remove trailing '&' if left behind
    }

    removeSortParam(url) {
        return url.replace(/(\?|&)sort=[^&]*/g, (match, p1) => (p1 === '?' ? '?' : ''))
            .replace(/\?$/, '') // Remove trailing '?' if left behind
            .replace(/&$/, '') // Remove trailing '&' if left behind
    }

    cleanUrl(url) {
        return url.replace(/\?&/g, '?')
    }

    togglePanel() {
        if ($('.panel').is(':visible')) {
            this.$body.removeClass('__overlay __show-open')
            $('.js_open-filter, .js_open-sort').removeClass('__active')
            $('.js_filter, .js_sort').slideUp(0)
        }
    }

    onChange(el) {
        this.$body.on('change', el, () => {
            this.currPage = 1
            this.getProducts()
        })
    }

    onChangeSize(el) {
        this.$body.on('change', el, (e) => {
            e.preventDefault()
            $(e.target).next().trigger('click')
            this.currPage = 1
            this.getProducts()
        })
    }

    removeDoubleSort() {
        const isMobile = window.matchMedia('(max-width: 991.98px)').matches
        $('.js_sort-checkbox').prop('disabled', !isMobile)
        $('.js_sort-select').prop('disabled', isMobile)
    }

    onChangePage(btn) {
        this.$body.on('click', btn, (e) => {
            e.preventDefault()
            this.currPage = $(e.target).attr('data-page')
            this.getProducts()
            this.scrollTop()
        })
    }

    scrollTop() {
        $('html, body').animate({ scrollTop: $('body').offset().top - 100 }, 500)
    }

    initScrollStyle(el) {
        if ($(el).length) {
            $(el).mCustomScrollbar({
                theme: 'dark',
                advanced: { updateOnContentResize: true }
            })
        }
    }

    unselectList(el) {
        this.$body.on('click', el, (e) => {
            e.preventDefault()
            let list = $(e.target).attr('data-list')
            this.currPage = 1
            this.updateParams(list)
            this.getProducts(this.data)
        })
    }

    updateParams(list) {
        let params = new URLSearchParams(this.data)
        for (let key of params.keys()) {
            if (key.startsWith(list)) {
                params.delete(key)
            }
        }
        this.data = params.toString()
    }

    clearFilter(el) {
        this.$body.on('click', el, (e) => {
            e.preventDefault()
            this.getProducts(null, true)
        })
    }

    clearItem(el) {
        let _this = this
        this.$body.on('click', el, function (e) {
            e.preventDefault()
            const list = $(this).attr('data-list')
            const itemId = $(this).attr('data-id')
            let params = new URLSearchParams(_this.data)

            let newParams = new URLSearchParams()

            for (const [key, value] of params) {
                if (list.startsWith('prices')) {
                    if (!key.startsWith(list)) {
                        newParams.append(key, value)
                    }
                } else if (!(key.startsWith(list) && value == itemId)) {
                    newParams.append(key, value)
                }
            }

            _this.data = newParams.toString()
            _this.currPage = 1
            _this.getProducts(_this.data, false)
        })
    }
}
